import React, { useState } from 'react';
import OverviewTab from './OverviewTab';
import AnalyticsTab from './AnalyticsTab';
import SettingsTab from './SettingsTab';
import { ApiKey, getApiKey } from '../../services/apiService';
import abraLogo from '../../assets/abra-logo.png';

const SignOutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
       viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

interface TabsNavigationProps {
  apiKey: ApiKey | null;
  userId: string; // Add this property
}

export default function TabsNavigation({ apiKey, userId }: TabsNavigationProps) {
  const [activeTab, setActiveTab] = useState('overview');
  const [refreshKey, setRefreshKey] = useState(0); // Add a refresh key to force re-render
  const [latestApiKey, setLatestApiKey] = useState<ApiKey | null>(apiKey);
  
  const handleSignOut = () => { 
    window.location.href = '/'; 
  };


  const handleApiKeyCreated = async () => {
    if (apiKey) {

      const refreshedKey = await getApiKey(apiKey.user_id);
      setLatestApiKey(refreshedKey);
    }

    setRefreshKey(prev => prev + 1);
  };


  const handleNavigateToTab = (tabName: string) => {
    setActiveTab(tabName);
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1 className="dashboard-title">
          <img src={abraLogo} alt="Abra Logo" className="logo" />
          Console
        </h1>

        <button className="button-signout" onClick={handleSignOut}>
         <SignOutIcon />
         <span>Sign Out</span>
        </button>
      </header>
      
      <div className="dashboard-content">
        <div className="tabs-container">
          <nav>
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'analytics', label: 'Analytics' },
              { id: 'settings', label: 'Settings' }
            ].map(tab => (
              <button 
                key={tab.id}
                className={activeTab === tab.id ? 'active' : ''}
                onClick={() => setActiveTab(tab.id)}>
                {tab.label}
              </button>
            ))}
          </nav>

          <div className="tab-content" key={refreshKey}>
            {activeTab === 'overview' && (
              <OverviewTab 
              apiKey={latestApiKey || undefined} 
              userId={userId} 
              onApiKeyCreated={handleApiKeyCreated}
            />
            )}
            {activeTab === 'analytics' && (
              <AnalyticsTab 
                apiKey={latestApiKey || apiKey} 
                onNavigateToTab={handleNavigateToTab}
              />
            )}
            {activeTab === 'settings' && (
              <SettingsTab 
                apiKey={latestApiKey || apiKey}
                onNavigateToTab={handleNavigateToTab}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}